module.exports = __webpack_public_path__ + "a182b5aefe06849078b33bac5e95437f.svg";